<template>
  <div class="card border border-dashed border-gray-300">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <div class="fw-bold">Paciente</div>
          <div class="text-muted fs-7">Busque um cadastro ou informe os dados principais</div>
        </div>
        <button class="btn btn-sm btn-light-primary" type="button" @click="newPatient">
          <i class="bi bi-plus-lg me-1"></i>Novo
        </button>
      </div>

      <SearchPatient
          :id-father="'budget-patient'"
          :use-autocomplete="true"
          v-model="search"
          @onClick="selectPatient"/>

      <div class="row g-3 mt-1" v-if="isNew">
        <div class="col-md-5">
          <label class="form-label required">Nome</label>
          <input class="form-control form-control-solid" v-model="local.patient_name" required>
        </div>
        <div class="col-md-3">
          <PatientIdentityFields :form="local" cpf-field="patient_cpf" />
        </div>
        <div class="col-md-4">
          <label class="form-label">WhatsApp</label>
          <input class="form-control form-control-solid" v-mask="['(##) ####-####', '(##) #####-####']" v-model="local.patient_phone">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { patientIdentity } from '../../helpers/patientIdentity';
import SearchPatient from "@/components/SearchPatient.vue";
import {mask} from "vue-the-mask";

export default {
  name: "BudgetPatientSection",
  components: {SearchPatient},
  directives: {mask},
  props: ['patientId', 'patient', 'selectedLabel'],
  emits: ['select', 'new'],
  data() {
    return {
      search: this.selectedLabel || '',
      local: {...this.patient},
    }
  },
  computed: {
    isNew() {
      return this.patientId === -1;
    },
  },
  watch: {
    patient: {
      deep: true,
      handler(value) {
        if (this.samePatient(this.local, value)) return;
        this.local = {...value};
      },
    },
    selectedLabel(value) {
      this.search = value || '';
    },
    local: {
      deep: true,
      handler(value) {
        if (!this.isNew || this.samePatient(value, this.patient)) return;
        this.$emit('new', {...value});
      },
    },
  },
  methods: {
    samePatient(a, b) {
      return JSON.stringify(patientIdentity(a)) === JSON.stringify(patientIdentity(b))
          && a?.patient_name === b?.patient_name
          && a?.patient_cpf === b?.patient_cpf
          && a?.patient_phone === b?.patient_phone;
    },
    selectPatient(patient) {
      this.search = patient.patient_name;
      this.$emit('select', patient);
    },
    newPatient() {
      this.search = '';
      this.local = {patient_name: '', patient_cpf: '', patient_phone: ''};
      this.$emit('new', {...this.local});
    },
  },
}
</script>
